import {
  SET_USER_INFO,
  SET_CT_USER_INFO,
  USERINFO_STATUS,
  SET_USER_BEHAVIOR_TABLE,
} from '../constants/ActionTypes.js';

export const defaultState = {
  info: { id: 0, nickName: '', email: '', dcmType: '' },
  ctInfo: { id: 0, nickName: '', email: '', dcmType: '' },
};

export const user = (state = defaultState, action) => {
  let newState;
  switch (action.type) {
    case SET_USER_INFO:
      newState = { ...state, info: action.data };
      break;

    case SET_CT_USER_INFO:
      newState = { ...state, ctInfo: action.data };
      break;
    case USERINFO_STATUS:
      newState = defaultState;
      break;

    case SET_USER_BEHAVIOR_TABLE:
      newState = { ...state, behaviorTable: action.data };
      break;

    default:
      newState = state;
      break;
  }

  // window.localStorage.setItem(USERINFO_STATUS, JSON.stringify(newState));
  return newState;
};
